var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2293_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1103 20.91L13.8903 12.72L17.1303 12.3V11.28L10.8003 10.86L11.2203 17.19H12.2403L12.6603 13.95L20.8803 22.14L22.1103 20.91Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.875,
    width: 30.25,
    height: 30.25,
    stroke: "currentcolor",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2293_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fa28fcdf0876288008a2183856f7d068.svg";
export { ForwardRef as ReactComponent };